import { useId } from 'react'
import { StockArrowSvg } from '../SaF.styles'
import { useTheme } from 'styled-components'

type StockArrowProps = {
  boxHeight: number
  outValue: number
  inValue: number
  remainingStock: number
}

export default function StockArrow({
  boxHeight,
  outValue,
  inValue,
  remainingStock
}: StockArrowProps) {
  const arrowHeadId = useId()
  const { saf } = useTheme()

  if (!inValue || !outValue) {
    return null
  }

  const boxValue = Math.max(inValue, outValue)

  const y1Multiplier = (() => {
    if (outValue + remainingStock > inValue) {
      if (outValue >= inValue) {
        return 1 + remainingStock / outValue
      }

      return 1 + (outValue + remainingStock - inValue) / inValue
    }

    return 1
  })()

  const y2 = (() => {
    if (remainingStock === 0) {
      return boxHeight - 1
    }

    if (outValue + remainingStock > inValue) {
      return boxHeight * (inValue > outValue ? outValue / inValue : 1) + 1
    }

    return ((boxValue - remainingStock) / boxValue) * boxHeight + 1
  })()

  return (
    <StockArrowSvg>
      <defs>
        <marker
          id={arrowHeadId}
          viewBox='0 0 10 10'
          refX='5'
          refY='5'
          markerWidth='4'
          markerHeight='4'
          orient='auto-start-reverse'
        >
          <path d='M 0 0 L 10 5 L 0 10 z' />
        </marker>
      </defs>

      <line
        x1='0'
        y1={boxHeight * y1Multiplier - 1}
        x2={saf.pillsGap - 1}
        y2={y2}
        stroke='black'
        strokeWidth='1'
        markerEnd={`url(#${arrowHeadId})`}
      />
    </StockArrowSvg>
  )
}
